import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie'; // Cookie işlemleri için import

const PrivateRoute = ({ children }) => {
  // Cookie kontrolü: Eğer user_token yoksa giriş sayfasına yönlendir
  if (!Cookies.get('user_token')) {
    return <Navigate to="/" />;
  }

  return children; // Eğer cookie varsa, sayfayı göster
};

export default PrivateRoute;
